<div class="page-header">
  <div class="header-start">
    <h3 class="title">List Of Applications & Resources</h3>
  </div>
  <div class="header-end">

  </div>
</div>

<div class="table-responsive card card-table mb-3">
  <spinner [id]="'application-list-data'" [show]='loading'></spinner>

  <div class="sticky-table-wrapper">
    <table class="table table-striped table-bordered mb-0">
      <thead class="table-primary">
        <tr>
          <th rowspan="2">Application Name</th>
          <th colspan="4" class="text-center">List of Resources</th>
        </tr>
        <tr>
          <th>API'S</th>
          <th>URL'S</th>
          <th>Dashboards</th>
          <th>Widgets</th>
        </tr>
      </thead>
    <tbody>
      <tr *ngFor="let app of tableData">
        <td class="sticky-col" >{{ app.applicationName | titlecase }}</td>
        <!-- APIS -->
        <td >
           <div class="app-column view-height-40">
          <ng-container *ngIf="app['resources'] && app['resources']['APIs'] && app['resources']['APIs'].length > 0">
            <div class="d-flex flex-wrap gap-2 ">
              
              <button mat-flat-button title="API's" *ngFor="let api of app['resources']['APIs']; let i=index;"
                class="text-nowrap" color="accent" [title]="api.resourceName"
                (click)="assignResource(api,'API')" [disabled]="viewOnly">
                <span>{{api.resourceName | capitalizeFirst}} ({{actionNameMapping[api.resourceActionName]}})</span>
            </button>
            </div>
          </ng-container>
          <div *ngIf="!app['resources'] || !app['resources']['APIs'] || app['resources']['APIs'].length === 0">-
          </div>
          </div>

        </td>
        <!-- URLS -->
        <td>
          <div class="app-column view-height-40">
          <ng-container *ngIf="app['resources'] && app['resources']['URLs'] && app['resources']['URLs'].length > 0">
            <div class="d-flex flex-wrap gap-2 ">
              <button mat-flat-button  *ngFor="let url of app['resources']['URLs']; let i=index;" [title]="url.resourceName"
                (click)="assignResource(url,'URL')" class="text-nowrap" color="accent" [disabled]="viewOnly">
                <span>{{url?.resourceName | capitalizeFirst}} ({{actionNameMapping[url.resourceActionName]}})</span>
            </button>
            </div>
          </ng-container>
          <div *ngIf="!app['resources'] || !app['resources']['URLs'] || app['resources']['URLs'].length === 0">-
          </div>
        </div>
        </td>
        <!-- Dashboards -->
        <td >
          <div class="app-column view-height-40">
            <ng-container
              *ngIf="app['resources'] && app['resources']['Dashboards'] && app['resources']['Dashboards'].length > 0">
             @if(app['resources']['Dashboards'].length >= 1 && app['resources']['Dashboards'][0].resourceId) {
                <div class="d-flex flex-wrap gap-2">
                 @for(resource of app['resources']['Dashboards']; track resource) {
                    <button mat-flat-button  [title]="resource.resourceName" [disabled]="viewOnly"
                      (click)="assignResource(resource,'Dashboard')" color="accent" class="text-nowrap">
                      {{resource?.resourceName | capitalizeFirst}} ({{actionNameMapping[resource.resourceActionName]}})
                    </button>
                }
                </div>
              } @else {
                
                     <div class="accordion w-100">
                    <ng-container *ngFor="let resource of app['resources']['Dashboards']; " >
                    
                      <!-- Only show if filtered pages and forms are available -->
                      <div class="panel mb-2" >
                    
                        <!-- Accordion Header -->
                        <div class="panel-header d-flex justify-content-between align-items-center p-2"
                          (click)="resource.expanded = !resource.expanded" style="cursor:pointer; user-select:none;">
                    
                          <span class="flex-fill fw-400" [title]="resource.page_name.length > 25 ? resource.page_name : ''">
                            {{ resource.page_name | titlecase | slice:0:25 }}{{ resource.page_name.length > 25 ? '...' : '' }}
                          </span>
                    
                          <span>
                            <span class="chip">
                              {{ ((resource.forms?.length || 0) + (resource.pages?.length || 0))  }}
                            </span>
                          </span>
                        </div>
                    
                        <!-- Accordion Content -->
                        <div class="panel-content p-1" [hidden]="!resource.expanded">
                    
                          <!-- Pages Section -->
                          <div>
                            <div class="fw-400 mb-1 ms-2">Page</div>
                           <ng-container *ngIf="resource.pages?.length; else noResources">
                          <div class="d-flex flex-wrap gap-2 ms-2">
                            <button mat-flat-button  *ngFor="let widget of resource.pages; let i=index;" [disabled]="viewOnly"
                            (click)="assignResource(widget,'Dashboard')" class="text-nowrap"  color="accent">
                            <span>{{widget?.resourceName | capitalizeFirst | truncate : 25}} ({{actionNameMapping[widget.resourceActionName]}})</span>
                          </button>
                        </div>
                      </ng-container>
                          </div>
                    
                          <!-- Forms Section -->
                          <div>
                            <div class="fw-400 my-2 ms-2">Forms</div>
                           <ng-container *ngIf="resource.forms?.length; else noResources">
                        <div class="d-flex flex-wrap gap-2 ms-2">
                          <button mat-flat-button [disabled]="viewOnly"  *ngFor="let widget of resource.forms; let i=index;" 
                          (click)="assignResource(widget,'Dashboard')" class="text-nowrap"  color="accent">
                          <span>{{widget?.resourceName | capitalizeFirst | truncate : 25}} ({{actionNameMapping[widget.resourceActionName]}})</span>
                        </button>
                      </div>
                    </ng-container>
                          </div>
                    
                        </div>
                      </div>
                    
                    </ng-container>
                    
                    <ng-template #noResources>
                      <p class="p-2 text-muted">No resource available</p>
                    </ng-template>
                    </div>
              }

            </ng-container>
            <ng-container *ngIf="app.applicationName == 'User Management'">

               <div class="d-flex flex-wrap gap-2">
                 @for(resource of app['resources']['others']; track resource) {
                    <button mat-flat-button [disabled]="viewOnly"  [title]="resource.resourceName" 
                      (click)="assignResource(resource,'Dashboard')" color="accent" class="text-nowrap">
                      {{resource?.resourceName | capitalizeFirst}} ({{actionNameMapping[resource.resourceActionName]}})
                    </button>
                }
                </div>
            </ng-container>
          </div>
          <div
            *ngIf="(!app['resources'] || !app['resources']['Dashboards'] || app['resources']['Dashboards'].length === 0) && app.applicationName != 'User Management'">
            -
          </div>
        </td>
        <!-- Widgets -->
        <td >
           <div class="app-column view-height-40">
          <ng-container
            *ngIf="app['resources'] && app['resources']['Widgets'] && app['resources']['Widgets'].length > 0">
            <!-- <mat-accordion [displayMode]="'flat'" togglePosition="before" [multi]="false" > -->
              @if(app['resources']['Widgets'].length >= 1 && app['resources']['Widgets'][0].resourceId) {
                <div class="d-flex flex-wrap gap-2 ">
                 @for(resource of app['resources']['Widgets']; track resource) {
                  <button mat-flat-button  [title]="resource.resourceName" [disabled]="viewOnly"
                      (click)="assignResource(resource,'Widget')" class="text-nowrap"  color="accent" >
                      <span>{{resource?.resourceName | capitalizeFirst}} ({{actionNameMapping[resource.resourceActionName]}})</span>
                  </button>
                }
                </div>
              } @else {
                    <div class="accordion w-100">
                  <ng-container *ngFor="let resource of app['resources']['Widgets'];" >
                    <!-- Show panel only if filtered widgets exist -->
                    <div class="panel mb-2" >
                      <!-- Panel header with toggle -->
                      <div class="panel-header d-flex justify-content-between align-items-center p-2 w-100"
                        (click)="resource.expanded = !resource.expanded" style="cursor: pointer; user-select: none;">
                        <span class="flex-fill fw-400" [title]="resource.page_name.length > 25 ? resource.page_name : ''">
                          {{ resource.page_name | titlecase | slice:0:25 }}{{ resource.page_name.length > 25 ? '...' : '' }}
                        </span>
                        <span>
                          <span class="chip">
                            {{ (resource.Widgets?.length || 0)  }}
                          </span>
                        </span>
                      </div>
                  
                      <!-- Panel content -->
                      <div class="panel-content p-1" [hidden]="!resource.expanded" >
                  
                        <ng-container *ngIf="resource.Widgets?.length; else noResources">
                    
                        <div class="d-flex flex-wrap gap-2 view-height-40" >
                          <button mat-flat-button [disabled]="viewOnly"  *ngFor="let widget of resource.Widgets; let i=index;" [title]="widget.resourceName"
                            (click)="assignResource(widget,'Widget')" class="text-nowrap"  color="accent">
                            <span>{{widget?.resourceName | capitalizeFirst | truncate : 25}} ({{actionNameMapping[widget.resourceActionName]}})</span>
                          </button>
                        </div>
                      </ng-container>
                      </div>
                  
                    </div>
                  </ng-container>
                  
                  <ng-template #noResources>
                    <p class="p-2 text-sm text-muted">No resource available</p>
                  </ng-template>
                  </div>
                }
              </ng-container>
              <!-- </mat-accordion> -->

             
          <div *ngIf="!app['resources'] || !app['resources']['Widgets'] || app['resources']['Widgets'].length === 0">-
          </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>